import { CancelRounded } from "@mui/icons-material";
import { Box, useTheme } from "@mui/material";
import Confirmation from "./Confirmation";

export function Declined({ onOkClicked }: { onOkClicked: () => void }) {
  const theme = useTheme();
  return (
    <Confirmation
      title="Declined"
      message="Your meeting has been declined."
      icon={
        <Box
          sx={{
            color: theme.palette.success.main,

            fontSize: theme.typography.fontSize * 5,
          }}
        >
          <CancelRounded
            sx={{
              color: theme.palette.error.main,
              height: "5em",
              width: "5em",
            }}
          />
        </Box>
      }
      onOkClicked={onOkClicked}
    />
  );
}
